import {
  SET_SELECTED_TRANSACTION,
  SET_TOTAL_AMOUNT_OF_TRANSACTIONS,
  SET_TOTAL_TRANSACTIONS,
  SET_TOTAL_VOLUME_OF_TRANSACTIONS,
  SET_TRANSACTIONS,
  SET_TRANSACTIONS_LOADED,
  SET_TRANSACTION_FILTER,
  TransactionAction,
  TransactionState,
} from '../types'

const initialState: TransactionState = {
  transactions: [],
  totalTransactions: 0,
  totalAmountOfTransactions: 0,
  totalVolumeOfTransactions: 0,
  isTransactionsLoaded: false,
  selectedTransaction: null,
  transactionFilter: {
    timeTo: new Date().getTime(),
    timeFrom: new Date(new Date().setDate(1)).getTime(),
    pageIndex: 1,
    pageSize: 15,
    stationName: '',
    pumpName: '',
    shiftName: '',
  },
}

export const transactionReducer = (
  state = initialState,
  action: TransactionAction
): TransactionState => {
  switch (action.type) {
    case SET_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload,
      }
    case SET_TRANSACTIONS_LOADED:
      return {
        ...state,
        isTransactionsLoaded: action.payload,
      }
    case SET_SELECTED_TRANSACTION:
      return {
        ...state,
        selectedTransaction: action.payload,
      }
    case SET_TRANSACTION_FILTER:
      return {
        ...state,
        transactionFilter: action.payload,
      }
    case SET_TOTAL_TRANSACTIONS:
      return {
        ...state,
        totalTransactions: action.payload,
      }
    case SET_TOTAL_AMOUNT_OF_TRANSACTIONS:
      return {
        ...state,
        totalAmountOfTransactions: action.payload,
      }
    case SET_TOTAL_VOLUME_OF_TRANSACTIONS:
      return {
        ...state,
        totalVolumeOfTransactions: action.payload,
      }
    default:
      return state
  }
}
